<!--
 * @Author: ningbo.kang
 * @Date: 2020-01-06 09:54:22
 * @LastEditors: wenpan.cao@ecarxgroup.com
 * @LastEditTime: 2023-08-08 15:56:38
 * @Description: 描述
 -->
<template>
    <div class="ant-upload-list ant-upload-list-text">
        <div
            class="ant-upload-list-item ant-upload-list-item-done"
            v-for="(list, index) in fileList"
            :key="index"
        >
            <template>
                <div class="ant-upload-list-item-info">
                    <span v-if="list.fileType === 'TOS'">
                        <!-- 预览 -->
                        <a-icon type="paper-clip" />
                        <a
                            target="_blank"
                            class="ant-upload-list-item-name"
                            :title="`${t('wg.file.preview')}:${list.name}`"
                            @click="downloadTos(list, 'preview')"
                            >{{ list.name }}</a
                        >
                    </span>
                    <span v-else-if="list.fileType === 'FEISHU'">
                        <!-- 预览 -->
                        <a-icon type="paper-clip" />
                        <a
                            target="_blank"
                            class="ant-upload-list-item-name"
                            :title="`${t('wg.file.preview')}:${list.name}`"
                            @click="downloadFeishu(list, 'preview')"
                            >{{ list.name }}</a
                        >
                    </span>
                    <span v-else>
                        <!-- 预览 -->
                        <a-icon type="paper-clip" />
                        <a
                            class="ant-upload-list-item-name"
                            :title="`${t('wg.file.preview')}:${list.name}`"
                            @click="previewURL(list.url, list.name, 'MINIO')"
                            >{{ list.name }}</a
                        >
                    </span>
                </div>
            </template>
            <!-- 下载 -->
            <a
                target="_blank"
                v-if="list.fileType === 'TOS'"
                class="file-item-download"
                :title="`${t('wg.file.download')}:${list.name}`"
                @click="downloadTos(list, 'download')"
            >
                <a-icon type="download" />
            </a>
            <a
                target="_blank"
                v-else-if="list.fileType === 'FEISHU'"
                class="file-item-download"
                :title="`${t('wg.file.download')}:${list.name}`"
                @click="downloadFeishu(list)"
            >
                <a-icon type="download" />
            </a>
            <a
                target="_blank"
                v-else
                class="file-item-download"
                :title="`${t('wg.file.download')}:${list.name}`"
                @click="downloadURL(list.url, list.name, 'MINIO', list)"
            >
                <a-icon type="download" />
            </a>
            <a-icon
                type="close-circle"
                class="file-item-download inner-delete"
                @click="deleteItem(list, index)"
                v-if="!disabled"
            />
        </div>
    </div>
</template>
<script>
import { t } from '../../locale';

// https://www.jianshu.com/p/10ac5c482193
// https://github.com/eligrey/FileSaver.js
function getBlob(url) {
    return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
            if (xhr.status === 200) {
                resolve(xhr.response);
            }
        };
        xhr.onerror = () => {
            // eslint-disable-next-line
            console.error('could not download file');
        };
        xhr.send();
    });
}
// 下载文件
function saveAs(blob, filename = 'download') {
    const URL = window.URL || window.webkitURL;
    const link = document.createElement('a');
    link.download = filename;
    link.rel = 'noopener';
    link.href = URL.createObjectURL(blob);
    setTimeout(() => {
        link.click();
    }, 0);
}

// http://10.43.200.81:18080/fts/fts-ui/blob/daily/1.0.0/src/utils/loadFile.js
export default {
    props: ['fileList', 'remote', 'disabled'],
    methods: {
        t(...args) {
            return t.apply(this, args);
        },
        async previewURL(url, name, type, item) {
            if (this.$parent.formContext) {
                const newUrl = url?.replace(
                    'https://minio.ecarx.com.cn',
                    'https://download.ecarxgroup.com/minio-fileserver/minio/file/download'
                );
                const preSignUrl = await this.$parent.formContext.previewURL(
                    newUrl,
                    name,
                    type,
                    item
                );
                if (preSignUrl) {
                    this.openPreview(preSignUrl);
                }
            }
        },
        downloadURL(url, name, type, item) {
            if (this.$parent.formContext) {
                const newUrl = url?.replace(
                    'https://minio.ecarx.com.cn',
                    'https://download.ecarxgroup.com/minio-fileserver/minio/file/download'
                );
                // const instanceId = this.$route.query?.instanceId;
                if (!newUrl && !item.uid) {
                    this.$message.error('文件不存在');
                    return false;
                }
                const downloadUrl = this.$parent.formContext.downloadURL(
                    newUrl,
                    name
                );
                this.openPreview(downloadUrl);
            }
            return '#';
        },
        download(url, name) {
            getBlob(url).then((blob) => {
                saveAs(blob, name);
            });
            return false;
        },
        // 调整成统一的预览生成逻辑
        previewTosFile(item, type = 'TOS') {
            const { uid } = item;
            const param = {
                fileIds: [uid],
                expiredMinutes: 1440,
            };
            this.remote.getTosFileView(param).then((res) => {
                const [{ viewUrl, fileName }] = res.content || [];
                const previewUrl = this.$parent.formContext.previewURL(
                    viewUrl,
                    fileName
                );
                this.openPreview(previewUrl);
            });
        },
        openPreview(url) {
            const a = document.createElement('a');
            a.setAttribute('href', url);
            a.setAttribute('target', '_blank');
            a.setAttribute('id', 'tos-file-click');
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(
                document.getElementById('tos-file-click')
            );
        },
        // 下载文件
        downloadTos(item, type = 'download') {
            const { uid: fileId, name = '' } = item;
            if (type === 'preview') {
                const previewUrl = this.$parent.formContext.previewTosUrl(
                    fileId,
                    name
                );
                this.openPreview(previewUrl);
            } else {
                const downloadUrl = this.$parent.formContext.downloadTosUrl(
                    fileId,
                    name
                );
                this.openPreview(downloadUrl);
            }
        },
        downLoadFile({ url, name }) {
            const link = document.createElement('a');
            link.href = url;
            link.download = name;
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
        },
        async downloadFeishu(file, type = 'download') {
            const { uid: fileId, serviceName, name } = file;
            if (type === 'download') {
                const downloadUrl = this.$parent.formContext.downloadFSUrl(
                    fileId,
                    serviceName,
                    name
                );
                this.openPreview(downloadUrl);
            } else {
                const preSignUrl = await this.$parent.formContext.previewFSURL(
                    fileId,
                    serviceName,
                    name
                );
                this.openPreview(preSignUrl);
            }
        },
        getBlob(url) {
            return new Promise((resolve) => {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', url, true);
                xhr.responseType = 'blob';
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        resolve(xhr.response);
                    }
                };

                xhr.send();
            });
        },
        // 下载文件
        saveAs(blob, filename) {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
        },
        load(file) {
            getBlob(file.url).then((blob) => {
                saveAs(blob, file.name);
            });
        },
        deleteItem(item, index) {
            this.$emit('delItem', index);
        },
    },
};
</script>
